import React, { useState, useEffect } from 'react'
import '../../App.scss'
import moment from 'moment';
import { Link } from 'react-router-dom';


//importing img
import foremdev from '../../img/foremdev.png'




export default function AsideRightHome(props) {
    console.log('aside:', props.data);
    const { data } = props

    data.map((post, index)=>{
        const {_id } = post

        console.log('AQUI', _id)
    })

    

    let last7DaysPosts = moment().subtract(7, 'days'); 
    //filtrar post por su semana
    const filteredByWeek = props.data.filter((post)=> {
        if( last7DaysPosts >= moment(post.createdAt)){
            //console.log('old', moment(post.createdAt).format('W'))
            return post
        }
    })
    
    const filteredByTagJS = props.data.filter( (post)=> {
        let tagList = post.tag_list.includes('JS')
        console.log('tag list:',tagList)
        return tagList
    })


    const filteredByTagDoggo = props.data.filter( (post)=> {

        let tagList = post.tag_list.includes('perro')
        console.log(tagList)
        return tagList
    })

    console.log(filteredByTagJS)
    //states

    console.log(props.posts)

    return (
        <>
            <aside class="d-none d-xl-block col-xl-3">
                <div class="card div-card mt-2">
                    <img class="img-aside-right" src={foremdev} alt="changelog" />
                    <div class="card-body">
                        <p class="">New Forem Changelog Entries!</p>
                        <p class="c-text-color"> "Lock Discussions on Posts"</p>
                        <p class="c-text-color"> "Accessibility Enhancements"</p>
                    </div>
                </div>

                <div id="news" className="card mt-4 r-card-list">

                    <div className="card-header font-weight-bold a-right">
                        <h4 className="mt-1">Listings</h4>
                        <a href="#" className="post-l">See all</a>
                    </div>

                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">React Developer - Full-Time, Remote
                            <div>
                                <p className="text-muted l-text">jobs</p>
                            </div>
                        </li>
                        <li className="list-group-item">Course Launch:Competitive Programming - Crack Your
                            Coding Interview
                            <div>
                                <p className="text-muted l-text">education</p>
                            </div>
                        </li>
                        <li className="list-group-item">DEVniverse Notion Template - The content creater's space
                            <div>
                                <p className="text-muted l-text">products</p>
                            </div>
                        </li>
                        <li className="list-group-item">Backkend Handbook for Ruby on Rails applications
                            <div>
                                <p className="text-muted l-text">products</p>
                            </div>
                        </li>
                        <li className="list-group-item">33 GitHub projects I have bookmarked and you should
                            <div>
                                <p className="text-muted l-text">misc</p>
                            </div>
                        </li>
                        <p className="text-center font-weight-bold mt-2">Create a Listing</p>
                    </ul>
                </div>

                {/* ---- SEARCH BY TAGS ---- ----*/}
                
                <div className="card mt-4">
                    <div className="card-header font-weight-bold" >
                        <h4>#news</h4>
                    </div>
                    <ul className="list-group list-group-flush">
                    {
                            filteredByWeek.map((post, index) => {
                                const {_id, title, user} = post
                                return (
                                    <li className="list-group-item" key={index} ><Link to={`/postDetail/${_id}`}  className="post-list" >{title}</Link>
                                        <div>
                                            {<p className="text-muted l-text">{user.name}</p>}
                                        </div>
                                    </li>
                                )
                            })                   
                        }

                    </ul>

                    {/* ---- TAG 2 ---*/}
                </div>

                <div id="help" className="card mt-4">
                    <div className="card-header font-weight-bold">
                        <h4>#JS</h4>
                    </div>
                        <ul id="helpPost" className="list-group list-group-flush">
                        {
                            filteredByTagJS.map((post, index) => {
                                const {_id, title, user} = post
                                return (
                                    <li className="list-group-item" key={index} ><Link to={`/postDetail/${_id}`}  className="post-list" >{title}</Link>
                                        <div>
                                            {<p className="text-muted l-text">{user.name}</p>}
                                        </div>
                                    </li>
                                )
                            })
                        }
                        </ul>
                </div>
                {/* ---- SEARCH BY TAGS ---- ----*/}
                <div id="help" className="card mt-4">
                    <div className="card-header font-weight-bold">
                        <h4>#perro</h4>
                    </div>
                    <ul className="list-group list-group-flush">
                        {
                            filteredByTagDoggo.map((post, index) => {
                                const {_id, title, user} = post
                                return (
                                    <li className="list-group-item" key={index} ><Link to={`/postDetail/${_id}`}  className="post-list" >{title}</Link>
                                        <div>
                                            {<p className="text-muted l-text">{user.name}</p>}
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>

            </aside>
        </>
    )
}